import { ASSETS_URL } from "./env";

export const FEATURE_ICONS_PATH = `${ASSETS_URL}/images/icons/`;

export const PRIVACY_LINK = "https://vitotechnology.com/privacy-policy.html";

export const TERMS_LINK = "https://vitotechnology.com/terms-of-use.html";
